module.exports = __webpack_public_path__ + "img/vertical_6_7_8019.9dbc1782.png";